<h1 class="redeem-reward-heading d-flex justify-content-between align-items-center">
  <div class="d-flex align-items-center">
    <a (click)="mobileBack()">
      <img
        *ngIf="isMobile == true"
        [src]="environment1 + 'assets/images/arrow-left.png'"
        class="img-fluid me-2"
        loading="lazy"
        style="height: 24px"
      />
    </a>
    <span>Wallet Balance</span>
  </div>

  <div class="tnc-wrapper d-flex align-items-center" (click)="TnCredirect()">
    <span class=" me-1">T&C applied</span>
    <img [src]='environment1 + "assets/images/chevron-right.svg"' alt="">
  </div>
</h1>

<div class="container my-4">
  <!-- Points Summary -->
  <div class="row text-center mb-4" style="height: auto">
    <div class="col-12 col-md-4 col-sm-4">
      <div class="points-summary">
        <img
          [src]="environment1 + 'assets/images/Vector.webp'"
          alt="vector-image"
        />
        <h3>{{ userBalance?.total_earn }}</h3>
        <span>Points</span>
        <br />
        <span>Earned</span>
      </div>
    </div>
    <div class="col-12 col-md-4">
      <div class="points-summary">
        <img
          [src]="environment1 + 'assets/images/ph_coin-vertical-light.webp'"
          alt="ph_coin-vertical-light"
        />
        <h3>{{ userBalance?.total_burn }}</h3>
        <span>Points</span>
        <br />
        <span>Redeemed</span>
      </div>
    </div>
    <div class="col-12 col-md-4">
      <div class="points-summary">
        <img
          [src]="environment1 + 'assets/images/carbon_in-progress.webp'"
          alt="carbon_in-progress"
        />
        <h3>{{ userBalance?.total_inprocess }}</h3>
        <span>Points</span>
        <br />
        <span>In-Progress</span>
      </div>
    </div>
  </div>
  <!-- Available Balance -->
  <div>
    <div class="available-balance text-center my-4">
      <h3>
        <span
          ><img
            [src]="environment1 + 'assets/images/Layer_2.webp'"
            alt="Layer-image" /></span
        >{{ userBalance?.user_balance_list[0]?.current_balance }}
      </h3>
      <p>Available</p>
    </div>
  </div>

  <!-- Coupon Information -->
  <!-- <div class="coupons-info d-flex justify-content-between align-items-center mb-3">
    <div class="d-flex align-items-center">
      <img [src]="environment1 + 'assets/images/hugeicons_coupon-percent.webp'" alt="hugeicons_coupon-percent">
      <span>You have earned 2 coupons</span>
    </div>
    <a href="#" class="text-primary">View them ></a>
  </div> -->

  <!-- My Statements -->
  <div class="statements-section">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5>My Statements</h5>
      <!-- <a href="#" class="text-primary">View all ></a> -->
      <a *ngIf="loyalityStatementData?.length > 0"

        (click)="navigateToRewardStatement($event)"
        class="text-primary cursor-pointer"
        >View all ></a
      >
    </div>
    <!-- Statement Items -->

    <div
      *ngFor="let item of loyalityStatementData | slice : 0 : 3"
      class="statement-card mb-3"
    >
      <div class="row">
        <ng-container *ngIf="item.transaction_type === 'ACC'">
          <div class="col-12 mb-2">
            <strong>{{ item.lead_acc_list?.[0].ppl ?? "-" }}</strong>
          </div>
          <!-- Vc Number -->
          <div class="col-md-3 col-6">
            <p>Vc No</p>
            <span>{{ item.lead_acc_list?.[0].vc ?? "-" }}</span>
          </div>
          <!-- Accuumulated Point -->
          <div class="col-md-3 col-6">
            <p>
              Accumulated
            </p>
            <span>₹{{ item.points ?? "-" }}<svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="green"
              class="bi bi-plus"
            >
              <circle cx="12" cy="12" r="10" fill="#006400" />
              <path
                d="M12 8a.5.5 0 0 1 .5.5v3.5h3.5a.5.5 0 0 1 0 1h-3.5v3.5a.5.5 0 0 1-1 0v-3.5H8a.5.5 0 0 1 0-1h3.5V8.5A.5.5 0 0 1 12 8z"
                fill="white"
              />
            </svg></span>
          </div>
          <!--  TotalAccuumulated Point -->
          <div class="col-md-3 col-6">
            <p>Total Accumulated</p>
            <span>₹{{ item.points ?? "-" }}</span>
          </div>
        </ng-container>

        <ng-container *ngIf="item.transaction_type === 'RED'">
          <!-- Gift Card Name -->
          <div class="col-12 mb-2">
            <strong>{{ item.product_name ?? "-" }}</strong>
          </div>
          <!-- Quantity -->
          <div class="col-md-3 col-6">
            <p>Qty</p>
            <span>{{ item.quantity ?? "-" }}</span>
          </div>
          <!-- Redeemed Amount -->
          <div class="col-md-3 col-6">
            <p>Redeemed</p>
            <span>₹{{ item.points ?? "-" }}&nbsp;<svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              class="bi bi-minus"
            >
              <!-- Circle Background -->
              <circle cx="12" cy="12" r="10" fill="orange" />
              <!-- Minus Icon -->
              <path
                d="M8 12a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5z"
                fill="white"
              />
            </svg>
            </span>
          </div>
          <!-- Remaining Amount -->
          <div class="col-md-3 col-6">
            <p>Total Redeemed</p>
            <span>₹{{ item.total_points ?? "-" }}</span>
          </div>
        </ng-container>
        <!-- Payment Status -->
        <div class="col-md-3 col-6 text-end">
          <p>Payment Status</p>
          <!-- <p *ngIf="item.status === 'PROCESSING'">
            <span
              ><img
                [src]="environment1 + 'assets/images/clock.webp'"
                alt="processing-clock-img"
                class="imgimg" /></span
            >Processing
          </p> -->
          <p style="color: #1F1F1F;" *ngIf="item.status === 'PROCESSING' || item.status === 'INPROCESS'">
            <span>
              <img
                [src]="environment1 + 'assets/images/clock.webp'"
                alt="processing-clock-img"
                class="imgimg"
              />
            </span>
            Processing
          </p>

          <p style="color: #1F1F1F;" *ngIf="item.status === 'COMPLETE'">
            <span
              ><img
                [src]="environment1 + 'assets/images/tick-circle.webp'"
                alt="confirmed-clock-img"
                class="imgimg" /></span
            >Confirmed
          </p>
          <p style="color: #1F1F1F;" *ngIf="item.status === 'PENDING'"><span><img [src]="environment1 + 'assets/images/clock.webp'"
            alt="confirmed-clock-img" class="imgimg"></span>Pending</p>
          <p style="color: #1F1F1F;" *ngIf="item.status === 'CANCELED' || item.status === 'CANCELLED'"><span><img [src]="environment1 + 'assets/images/clock.webp'"
            alt="confirmed-clock-img" class="imgimg"></span>Cancelled</p>
            <p style="color: #1F1F1F;" *ngIf="item.status === 'CANCELLED_OR_LOST'"><span><img [src]="environment1 + 'assets/images/clock.webp'"
              alt="confirmed-clock-img" class="imgimg"></span>Cancelled or Lost</p>
        </div>
      </div>
    </div>
    <!-- Explore Reward Center Button -->
    <div
      class="col-12 text-end mt-3 explore-button-container  d-sm-blockd-none "
    >
      <button
        type="button"
        class="btn btn-primary btn-lg ps-5 pe-5 pt-md-3 pb-md-3"
        (click)="openRewardCenter()"
        title="Click here to explore reward center"
        style="
          background: linear-gradient(99.61deg, #1c429e 1.46%, #0a0a5f 101.08%);
          border: none;
        "
      >
        Redeem Points
      </button>
    </div>
  </div>
</div>
